export let hrms73eColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'trainingDate',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '80',
    style: 'min-width: 200px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'dtetrst',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '90',
    style: 'min-width: 120px;',
    class: 'align-center',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '100',
    style: 'min-width: 120px;',
    class: 'align-center',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'val_name',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'val_date',
    name: '',
    labelCodapp: 'HRMS73E1',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}
export let hrms73eMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms73e.js